import { render, staticRenderFns } from "./wechatChargeUser.vue?vue&type=template&id=53e64b4b&scoped=true"
import script from "./wechatChargeUser.vue?vue&type=script&lang=js"
export * from "./wechatChargeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e64b4b",
  null
  
)

export default component.exports